<template>
  <div class="work-world" v-trace-click="'n.3386.6049.0'">
    <div class="news-header">
      <h2 class="home-model-title">云杉新闻</h2>
      <a href="https://ins.yunshanmeicai.com/index.php?s=/news/index/index.html" target="_blank">
        <span>
          查看更多
          <i class="el-icon-arrow-right"></i>
        </span>
      </a>
    </div>
    <div class="news-container">
      <a
        :href="item.url"
        class="news-item"
        target="_blank"
        v-for="(item, index) in news"
        :key="index"
      >
        <div class="img-container">
          <img :src="item.img_url" alt v-if="item.img_url" />
          <img src="@/assets/img/fixed-img.png" v-else />
        </div>
        <div class="content-text">
          <h3 class="title">{{ item.title }}</h3>
          <p class="description">{{ item.description }}</p>
          <p class="create-time">
            发布于
            {{
            new Date(item.create_time * 1000 + 8 * 3600 * 1000)
            .toJSON()
            .substr(0, 19)
            .replace("T", " ")
            }}
            <span>浏览&nbsp;{{item.view}}</span>
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      news: [],
      newsList: []
    };
  },
  methods: {
    getNewList () {
      _api.home.getNewList().then(res => {
        this.news = res.data.splice(0, 2)
        this.newsList = res.data.splice(0, 3)
      })
    }
  },
  created () {
    this.getNewList()
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.news-header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  span {
    color: #909399;
    cursor: pointer;
    line-height: 16px;
  }
}

.news-container {
  width: 895px;
  height: 314px;
  border: 1px solid rgba(237, 237, 237, 1);
  padding: 5px 26px 0 19px;
  .news-item {
    height: 100px;

    .content-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      .title {
        font-size: 18px;
        color: #444;
        margin-bottom: 7px;
        line-height: 18px;
        font-family: PingFangSC-Regular;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        &:hover {
          color: #4272ab !important;
        }
      }
      .description {
        color: #909399;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .create-time {
        color: #909399;
        margin-top: auto;
        font-size: 12px;
        line-height: 12px;
        span {
          float: right;
        }
      }
    }
  }
  .news-item {
    display: flex;
    padding: 25px 0;
    .img-container {
      width: 180px;
      height: 100px;
      img {
        width: 180px;
        height: 100px;
      }
    }
    .content-text {
      margin-left: 19px;
      p {
        line-height: 24px;
        color: #666;
        font-size: 14px;
        &:hover {
          color: #4272ab !important;
        }
      }
    }
  }
}
</style>
